(function() {
  // Initialize all featured collection sections on the page
  function initializeAllSections() {
    const bsElements = document.querySelectorAll('.bs');
    
    bsElements.forEach((root) => {
      // Find the parent section wrapper (Shopify wraps sections in an element with id starting with 'shopify-section-')
      let section = root.closest('[id^="shopify-section-"]');
      if (!section) return;
      
      const sectionId = section.id;
      
      // Check if this section is already initialized
      if (root.dataset.initialized === 'true') {
        // Clean up existing instance if any
        const existingInstance = root.dataset.swiperInstance;
        if (existingInstance && window.Swiper) {
          try {
            const swiperEl = root.querySelector('.bs__swiper');
            if (swiperEl && swiperEl.swiper) {
              swiperEl.swiper.destroy(true, true);
            }
          } catch (e) {
            console.warn('Error destroying existing Swiper:', e);
          }
        }
      }
      
      let swiperInstance = null;

      function cleanup() {
        if (swiperInstance) {
          try {
            swiperInstance.destroy(true, true);
          } catch (e) {
            console.warn('Error destroying Swiper:', e);
          }
          swiperInstance = null;
        }
      }

      function initializeSwiper() {
        cleanup();

        if (!root) return;

        const swiperEl = root.querySelector('.bs__swiper');
        const prevEl = root.querySelector('.bs__nav--prev');
        const nextEl = root.querySelector('.bs__nav--next');
        const currentEl = root.querySelector('[data-bs-current]');
        const totalEl = root.querySelector('[data-bs-total]');

        if (!swiperEl) return;

        const slidesCount = swiperEl.querySelectorAll('.swiper-slide')?.length || 0;
        if (totalEl) totalEl.textContent = String(slidesCount);
        
        if (!window.Swiper || slidesCount === 0) return;
        
        swiperInstance = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 450,
          navigation: { prevEl, nextEl }
        });

        const updateCounter = () => {
          if (!currentEl || !swiperInstance) return;
          currentEl.textContent = String(swiperInstance.realIndex + 1);
        };

        updateCounter();
        swiperInstance.on('slideChange', updateCounter);
        
        // Mark as initialized
        root.dataset.initialized = 'true';
      }

      // Initialize this section
      initializeSwiper();

      // Handle section reload in theme editor
      document.addEventListener('shopify:section:load', function(event) {
        if (event.target && event.target.id === sectionId) {
          setTimeout(initializeSwiper, 50);
        }
      });
    });
  }

  // Ensure code runs after DOMContentLoaded
  function init() {
    initializeAllSections();

    // Re-initialize when sections are loaded (for theme editor)
    document.addEventListener('shopify:section:load', function(event) {
      setTimeout(initializeAllSections, 50);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded, run immediately
    init();
  }
})();
